module.exports = __webpack_public_path__ + "img/dodArrowIcon.b78b7aaa.svg";